export default __webpack_public_path__ + "static/media/keynote19.af37b4f4.jpeg";